<script setup lang="ts">
/**
 * Clipped full-match sidebar list: same layout shell as `Playlists/List.vue`,
 * separate component so toolbar / row actions differ from playlists.
 */
import type { IVideoClippedListItem } from "~/videos/helpers/get-angles-value";

defineProps<{
  items: IVideoClippedListItem[];
  activeItem: IVideoClippedListItem | null;
  isVideoPaused?: boolean;
}>();

const emit = defineEmits<{
  itemClick: [item: IVideoClippedListItem];
}>();

const user = useUser();
const { t } = useI18n();
</script>

<template>
  <div class="h-96 w-full bg-white dark:bg-neutral-dark-700 lg:h-[calc(100%-83px)]">
    <div class="h-full">
      <div class="relative h-full overflow-hidden">
        <!-- Toolbar row: mirrors Playlists/List.vue (selection row); slots for clipped-specific actions -->
        <div
          v-if="user"
          class="relative mt-1.5 flex h-[39px] items-center justify-between"
        >
          <div class="flex gap-4 px-4">
            <slot name="toolbar-leading">
              <span class="text-sm font-medium text-neutral-light-800 dark:text-neutral-dark-200">
                {{ t("labels.clip") }}
                <span class="text-neutral-light-600 dark:text-neutral-dark-300"> ({{ items.length }}) </span>
              </span>
            </slot>
          </div>
          <div class="flex items-center gap-4 px-4">
            <slot name="toolbar-actions" />
          </div>
        </div>

        <div class="h-[calc(100%-46px)] gap-1 overflow-auto px-4">
          <VideoClippedListItem
            v-for="item in items"
            :key="item.id"
            :item="item"
            :active-item="activeItem"
            :is-video-paused="isVideoPaused"
            @item-click="emit('itemClick', $event)"
          >
            <template #actions>
              <slot
                name="actions"
                :item="item"
              />
            </template>
          </VideoClippedListItem>
        </div>
      </div>
    </div>
  </div>
</template>
